export default "__VITE_ASSET__Bck7QBzd__"